module.exports = __webpack_public_path__ + "static/image 107-8c10a78fb496923b1d7fef3b89bcd337.png";